import { Button, Content, DialogRef, InputSearch, QueryState, QueryStateContent, Stack } from 'src/app/components';
import { useTabDraw } from './LuckyDrawDetailTabDraw.hook';
import TabDrawInfoContent from './TabDrawContent/TabDrawInfoContent';
import { usePermissions } from 'src/app/hooks/permissions-hook';
import { DrawingModel } from '../../../models/LuckyDraw.model';
import { useRef } from 'react';
import { useApiParams } from 'src/app/hooks';
import TabDrawSetAsWinnerPopup from './TabDrawContent/TabDrawSetAsWinnerPopup';


export default function LuckyDrawDetailTabDraw() {
  const state = useTabDraw();
  const data: DrawingModel = state.drawingDetail.data;
  const permission = usePermissions();
  const setAsWinnerRef = useRef<DialogRef>(null);
  const [_params] = useApiParams();

  return (
    <>
      <Content className='px-8 py-6'>
        <InputSearch />
      </Content>
      {!_params.search && 
        <QueryStateContent title="No Data" description="Search Print ID / Coupon ID First to show Data." />
      }
      {_params.search && 
        <QueryState query={state.drawingDetail}>
          <TabDrawInfoContent data={data} />
        </QueryState>
      }
      {data &&
      <Stack className="border-t pt-4 mt-4 border-neutral-200 pb-1 pr-[0.25rem]" direction="row" gap={4}>
        <Stack direction="row" justify="end" gap={4}>
          {permission.setVisibleByAccess(
            ['manage_campaign_lucky_draw.update'],
            <Button className='px-8' disabled={!data.can_set_as_winner} onClick={()=>(setAsWinnerRef.current?.show(data))}>Set as Winner</Button>
          )}
        </Stack>
      </Stack>}
      <TabDrawSetAsWinnerPopup dialogRef={setAsWinnerRef} submit={()=>(state.drawingDetail.refetch())} />
    </>
  )
}